import { useState } from 'react';
import { Container, Nav, Navbar as RBNavbar } from 'react-bootstrap';
import logo from '../assets/logo.jpg';
import appConfig from '../config/appConfig';
import styles from '../styles/navbar.module.css';

export default function Navbar() {
  // State to control the visibility of the custom sidebar
  const [showSidebar, setShowSidebar] = useState(false);

  // Define navigation items
  const navItems = [
    { name: 'Home', href: '#home' },
    { name: 'Services', href: '#features-services' },
    { name: 'About Us', href: '#aboutus' },
    { name: 'Contact', href: '#contact' },
  ];

  // Function to close the sidebar, used on link clicks and overlay click
  const closeSidebar = () => setShowSidebar(false);

  return (
    <>
      {/* Main Bootstrap Navbar (visible on all screen sizes, but its collapse part is desktop-only) */}
      <RBNavbar
        expand="lg"
        className={`${styles.navbarSticky} shadow-sm`}
        // Bootstrap's 'expanded' prop now mirrors our custom 'showSidebar' state for consistency with toggler icon
        expanded={showSidebar}
        // Toggle our custom sidebar state when the Bootstrap Toggler is clicked
        onToggle={() => setShowSidebar(!showSidebar)}
      >
        <Container fluid className="px-3 py-2 d-flex align-items-center">
          {/* Company Logo and Brand Name */}
          <RBNavbar.Brand href="#home" className="d-flex align-items-center text-decoration-none">
            <img
              src={logo}
              alt="Shikitari Japanese Language Academy Logo"
              style={{ height: '45px', marginRight: '10px', flexShrink: 0 }}
            />
            <span className={styles.navbarBrandText}>
              {appConfig.company.name}
            </span>
          </RBNavbar.Brand>

          {/* Hamburger Toggle Button (visible on mobile/tablet) */}
          <RBNavbar.Toggle
            aria-controls="basic-navbar-nav"
            className={`ms-auto ${showSidebar ? styles.togglerOpen : ''} ${styles.customToggler}`}
          >
            {/* These are the hamburger lines that animate into an 'X' */}
            <div className={styles.hamburgerLine}></div>
            <div className={styles.hamburgerLine}></div>
            <div className={styles.hamburgerLine}></div>
          </RBNavbar.Toggle>

          {/* Desktop Navigation Links (hidden on mobile/tablet) */}
          {/* The 'd-none d-lg-flex' classes ensure this collapse is only active on large screens */}
          <RBNavbar.Collapse id="basic-navbar-nav" className="d-none d-lg-flex">
            <Nav className="ms-auto">
              {navItems.map((item, idx) => (
                <Nav.Link
                  key={idx}
                  href={item.href}
                  className="fw-bold text-nowrap"
                  style={{ color: 'var(--primary-brand-dark)' }}
                  onClick={closeSidebar}
                >
                  {item.name}
                </Nav.Link>
              ))}
              <Nav.Link
                href="#contact"
                className="btn fw-bold ms-lg-3 mt-2 mt-lg-0 px-4 py-2"
                style={{
                  backgroundColor: 'var(--primary-brand-accent)',
                  color: 'var(--primary-brand-dark)',
                  border: 'none',
                  transition: 'background-color 0.3s ease',
                }}
                onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = 'var(--primary-brand-light)')}
                onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = 'var(--primary-brand-accent)')}
                onClick={closeSidebar}
              >
                Get in Touch
              </Nav.Link>
            </Nav>
          </RBNavbar.Collapse>
        </Container>
      </RBNavbar>

      {/* CUSTOM SLIDING SIDEBAR FOR MOBILE/TABLET */}
      <div className={`${styles.sidebarMenu} ${showSidebar ? styles.show : ''} d-lg-none`}>
        {/* Overall Sidebar Header Container (top row with X and Branding) */}
        <div className={styles.sidebarHeaderContainer}>
          {/* Close Button (top-left) */}
          <button className={styles.sidebarCloseButton} onClick={closeSidebar} aria-label="Close menu">
            {/* CSS will draw the X */}
          </button>

          {/* Container for Logo, Line, and Text (stacked and aligned right) */}
          <div className={styles.sidebarBranding}>
            <img
              src={logo}
              alt="Shikitari Japanese Language Academy Logo"
              style={{ height: '100px' }} /* Logo height */
            />
            <div className={styles.sidebarLine}></div> {/* Line after logo */}
            <span className={styles.sidebarBrandText}>
              {appConfig.company.name}
            </span>
          </div> {/* End sidebarBranding */}
        </div> {/* End sidebarHeaderContainer */}

        {/* NEW: Line after the entire brand section, before nav list. This line will be full width. */}
        <div className={`${styles.sidebarLine} ${styles.fullWidthLine}`}></div>

        {/* Sidebar Navigation Links (starts below the entire header section) */}
        <Nav className="flex-column px-4 py-3">
          {navItems.map((item, idx) => (
            <Nav.Link
              key={idx}
              href={item.href}
              className={`fw-bold mb-2 ${styles.sidebarNavLink}`}
              onClick={closeSidebar}
            >
              {item.name}
            </Nav.Link>
          ))}
          <Nav.Link
            href="#contact"
            className={`btn fw-bold mt-3 px-4 py-2 ${styles.sidebarBtnGetInTouch}`}
            onClick={closeSidebar}
          >
            Get in Touch
          </Nav.Link>
        </Nav>
      </div>

      {/* OVERLAY for when the sidebar is open */}
      <div
        className={`${styles.sidebarOverlay} ${showSidebar ? styles.show : ''} d-lg-none`}
        onClick={closeSidebar}
      ></div>
    </>
  );
}